<script setup lang="ts">
import DashboardLayout from '@/onenetwork/layouts/DashboardLayout.vue'
</script>
<template>
  <dashboard-layout currentRoute="cs/popup" page-title="Quản lý thông báo Popup">
  </dashboard-layout>
</template>
